import { Component, Input, OnInit } from '@angular/core';
import { Select, Store } from '@ngxs/store';
import { Observable } from 'rxjs';
import { Decisioning } from '@app/app/interfaces/decisioning.model';
import { DecisioningState } from '@app/app/store/decisioning/decisioning.state';
import { GetBorrowerDecisioningForProduct } from '@app/app/store/decisioning/decisioning.actions';

@Component( {
  selector: 'app-decisioning',
  templateUrl: './decisioning.component.html',
  styleUrls: []
} )

export class DecisioningComponent implements OnInit {

  @Select( DecisioningState.decisioning ) decisioning$: Observable<Decisioning[]>;
  @Select( DecisioningState.loading ) loading$: Observable<boolean>;

  @Input() borrowerId: number;
  @Input() loanProductId: number;

  constructor(
    private store: Store,
  ) {
  }

  ngOnInit(): void {
    this.store.dispatch( new GetBorrowerDecisioningForProduct( this.borrowerId, this.loanProductId ) );
  }
}
